import React, { useEffect, useState, useRef } from 'react'
import Dashboardheader from './Dashboardcomponents/Dashboardheader'
import styles from "./Dashboard.module.css"
import Environmentpanel from './Dashboardcomponents/Environmentpanel'
import { Outlet, useParams, useLocation, useNavigate } from 'react-router-dom'
import { get_all_project_Api } from '../dashboardapi';
import { useToast } from "@chakra-ui/react";
import DashboardSidebar from './Dashboardcomponents/DashboardSidebar'

const Dashboard = () => {
    const [token, setToken] = useState("");
    const [projects, setProjects] = useState([]);
    const [isMobile, setIsMobile] = useState(false);
    const [toogleSidebar, setToogleSidebar] = useState(false);
    const { project } = useParams();
    const location = useLocation();
    const toast = useToast();
    const sidebarRef = useRef(null);

    const navigate = useNavigate();

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 770) {
                setIsMobile(true);
            } else {
                setIsMobile(false);
            }
        }
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            // If sidebar is open and click is outside sidebar
            if (toogleSidebar && sidebarRef.current && !sidebarRef.current.contains(event.target)) {
                setToogleSidebar(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [toogleSidebar]);


    useEffect(() => {
        if (location.state?.toastMessage) {
            setTimeout(() => {
                toast({
                    title: "Invalid Project",
                    description: location.state.toastMessage,
                    status: "error",
                    duration: 2000,
                    isClosable: false,
                });
            }, 500);
            navigate(location.pathname, { replace: true, state: {} });
        }
    }, [location.state, toast]);


    useEffect(() => {
        let token = localStorage.getItem("token")
        setToken(token)
    }, []);
    const handleSidebarItemClick = () => {
        setToogleSidebar(false);
    };

    return (
        <div className='container'>
            <div className={styles.dashboard_container}>

                <Dashboardheader />
                <main>
                    <div className={styles.main_row}>
                        {/* {
                        isMobile && (
                            <div className={styles.sidebarIcon}>
                                <button onClick={() => setToogleSidebar(prev => !prev)}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9 3H4C3.44772 3 3 3.44772 3 4V11C3 11.5523 3.44772 12 4 12H9C9.55228 12 10 11.5523 10 11V4C10 3.44772 9.55228 3 9 3Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M20 3H15C14.4477 3 14 3.44772 14 4V7C14 7.55228 14.4477 8 15 8H20C20.5523 8 21 7.55228 21 7V4C21 3.44772 20.5523 3 20 3Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M20 12H15C14.4477 12 14 12.4477 14 13V20C14 20.5523 14.4477 21 15 21H20C20.5523 21 21 20.5523 21 20V13C21 12.4477 20.5523 12 20 12Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M9 16H4C3.44772 16 3 16.4477 3 17V20C3 20.5523 3.44772 21 4 21H9C9.55228 21 10 20.5523 10 20V17C10 16.4477 9.55228 16 9 16Z" stroke="currentColo" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>



                                </button>
                            </div>
                        )
                    } */}
                        {/* {
                        (isMobile && toogleSidebar) && (
                            <>
                                <DashboardSidebar onItemClick={handleSidebarItemClick} />
                            </>
                        )
                    } */}
                        {/* {
                        (isMobile && toogleSidebar) && (
                            <div ref={sidebarRef}>
                                <DashboardSidebar />
                            </div>
                        )
                    } */}
                        {!isMobile && (
                            <DashboardSidebar />
                        )}

                        {isMobile && toogleSidebar && (
                            <div ref={sidebarRef}>
                                <DashboardSidebar ToogleSidebars={setToogleSidebar} />
                            </div>
                        )}


                        <div className={styles.main_content}>
                            <Outlet context={{ ToogleSidebars: setToogleSidebar }} />
                        </div>
                    </div>
                </main>
            </div>
        </div>
    )
}

export default Dashboard